import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = {
    inner: { type: String },
  };

  connect() {
    tippy(this.element, { content: this.innerValue, theme: "material" });
  }
}
